const ENGINEERED_SPEAKER_PATTERN = /\b(line array|event 210a)\b/i

export const isSpeakerRentalCatalogProduct = product => {
  if (!product?.categories?.includes('Sound/Main Speakers')) return false
  if (product.categories?.includes('Sound/Array')) return false
  if (ENGINEERED_SPEAKER_PATTERN.test(product.name || '')) return false

  return product.allow_pickup !== false
}

export const buildSpeakerRentalCatalogOffer = product => ({
  '@type': 'Offer',
  price: product?.price?.rental,
  priceCurrency: 'USD',
  itemOffered: {
    '@type': 'Service',
    name: product?.name,
    description: product?.description
  }
})

export const normalizeSpeakerFaq = questions => {
  if (!Array.isArray(questions) || !questions.length) return []

  return questions.map(question => {
    if (!/deliver and set up|pick up the speakers/i.test(question.question || '')) return question

    return {
      ...question,
      answer: 'Both. Choose warehouse pickup or professional delivery and setup after selecting your dates. This page serves Miami, Fort Lauderdale, and South Florida; availability, delivery pricing, and eligible fulfillment options are confirmed before checkout. For Central Florida, use our Orlando speaker rental page.'
    }
  })
}
